import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

import { CodeRemedyRoute } from '@/features/code-remedy/CodeRemedyRoute';
import { CodeRemedyFixLibraryTab, CodeRemedyLibraryTab } from '@/features/code-remedy/types';

// Map pre-rename ?tab= values (from old bookmarks / the /code-remedy redirect,
// which preserves the query string) onto the current tab names.
const LEGACY_LIBRARY_TAB: Record<string, CodeRemedyLibraryTab> = {
  Remedies: CodeRemedyLibraryTab.REMEDIES,
  Rules: CodeRemedyLibraryTab.RULES,
};

export const Route = createFileRoute('/_protected/t/$tenantId/code-modernization/')({
  component: RouteComponent,
  validateSearch: z.object({
    tab: z
      .preprocess((v) => (typeof v === 'string' ? (LEGACY_LIBRARY_TAB[v] ?? v) : v), z.nativeEnum(CodeRemedyLibraryTab))
      .optional()
      .catch(undefined),
    libraryTab: z.nativeEnum(CodeRemedyFixLibraryTab).optional().catch(undefined),
  }),
});

function RouteComponent() {
  const { tab, libraryTab } = Route.useSearch();
  return <CodeRemedyRoute tab={tab} libraryTab={libraryTab} />;
}
